// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getMessaging, onMessage } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyBHtgfd9o-TG3yia93if7QSSIGxSSPRgUE",
  authDomain: "print-karo-b1817.firebaseapp.com",
  projectId: "print-karo-b1817",
  storageBucket: "print-karo-b1817.firebasestorage.app",
  messagingSenderId: "353684517342",
  appId: "1:353684517342:web:e3c3631c79eb0c192e2d4f",
  measurementId: "G-MBS2YRLM00",
};


// Initialize Firebase
 const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const messaging = getMessaging(app);

// ✅ Export all necessary modules
export { app,auth, db, storage, ref, uploadBytes, getDownloadURL, messaging, onMessage };
